import { FontClass } from "@ui/types/enums/FontClass";
import { HeaderText } from "@ui/components/text/HeaderText";
import type { Props } from "@ui/components/text/HeaderText";

export function Header3(props: Omit<Props, "fontClass">) {
  return <HeaderText {...props} fontClass={FontClass.Header3} />;
}
